import { useBaseViewModel } from '@/common';
import { CenterEntity } from '@/domains/center/entities';
import { FindCenterByUseCase } from '@/domains/center/usecases/find.usecase';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CenterHttpRepository } from '../adapters/repositories';

export default function GetDetailCenter() {
  const getDetailCenter = new FindCenterByUseCase(new CenterHttpRepository());
  const [currentQueryParameters] = useSearchParams();
  const getId = currentQueryParameters.get('id');

  const { loading: loadingCenter, error: errorCenter, catchAction } = useBaseViewModel();
  const [detailCenter, setDetailCenter] = useState<{
    data: CenterEntity;
  }>({
    data: {
      id: '',
      name: '',
      shortName: '',
      hotLine: '',
      email: '',
      isActive: true,
      address: {
        country: { id: '', code: '', name: '' },
        city: { id: '', code: '', name: '' },
        district: { id: '', code: '', name: '' },
        ward: { id: '', code: '', name: '' },
        address: '',
      },
      coordinate: '',
      businessUnits: [],
    },
  });

  const actionGetDetail = () => {
    if (getId) {
      catchAction(async () => {
        const dataDetail = await getDetailCenter.find(getId);
        setDetailCenter({ data: dataDetail });
      });
    }
  };

  return {
    loadingCenter,
    errorCenter,
    detailCenter,
    actionGetDetail,
  };
}
